<template>
    <div class="report-wrap">
        <div>
            <div style="height: .6rem"></div>
            <div class="report-content">
                 <div class="report-title">
                    <p class="regcode">检测单号：<span>15242525263625555</span></p>
                    <div>
                        <img src="../assets/report.png" />
                    </div>
                </div>
                <div class="report-reginfo">
                    <h4>
                        检测基本信息
                    </h4>
                    <p>
                        <span>姓名 : <b>张天翼</b></span>
                        <span>性别 : <b>女</b></span>
                        <span>年龄 : <b>57岁</b></span>
                    </p>
                </div> 
                 <div class="results">
                     <h4>评估成绩</h4>
                    <p class="first-p">
                        <span>脑力值</span>
                        <span>超过同龄人</span>
                        <span>与同龄人相比</span>
                    </p>
                    <p class="two-p">
                        <b>62/100</b>
                        <b>75%</b>
                        <b>表现良好</b>
                    </p> 
                    <div class="results-img">
                        <div>
                            <img src="../assets/1.png" />
                        </div>
                        <div>
                            <img src="../assets/2.png" />
                        </div>
                    </div>
                </div> 
                <div class="jiedu-list">
                    <h4>成绩解读</h4>
                    <ul>
                        <li>
                            <h6>检测基本信息</h6>
                            <p>
                                您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。
                            </p>
                        </li>
                        <li>
                            <h6>强弱项分析</h6>
                            <p>
                                您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。
                            </p>
                        </li>
                        <li>
                            <h6>专家建议</h6>
                            <p>
                                您的综合能力表现良好，超过了70%的同龄人，请注意扬长避短，发挥优势，通过适当的认知训练保持优势的能力，提升弥补能力，保持大脑健康。
                            </p>
                        </li>
                    </ul>
                </div>
                <div class="report-footer">
                    <p>检测日期 : <span>2017年3月21日 </span></p>
                    <p>
                        六六脑 脑能力检测系统
                    </p>
                </div>
            </div>
            <div style="height: .7rem"></div>
        </div>
        <myheader></myheader> 
    </div>
</template>
<script>
    import myheader from "@/phonecomponents/pheader";
	const components = {
		myheader
	}
    export default {
        components: components,
        data() {
            return {
                myIScroll: null
            }
        },
        created() {
			var _this = this;
			setTimeout(function() {
				_this.myIScroll = new IScroll(".report-wrap", {
					prevenDefault: true
				})
			})
		},
        methods: {

        },
        updated(){
			this.myIScroll.refresh();
		}
    }
</script>
<style lang="scss">
    @import "../styles/core/reset.scss";
    .report-wrap{
        width: 100%;
		height: 100%;
        .report-content{
            background: #fff;            
            .report-title{
                font-size: .14rem;
                text-align: center;
                border-bottom: 1px dotted #249C24;
                margin: 0 .15rem;
                .regcode{
                    color: #249C24;
                    padding-top: .25rem;
                    font-size: .14rem;
                    font-weight: bold;
                }
                div{
                    img{
                        padding: .3rem 0 .6rem 0;
                    }
                }
            
            }
            .report-reginfo{
                text-align: center;
                border-bottom: 1px dotted #249C24;
                margin: 0 .15rem;
                h4{
                    font-size: .18rem;
                    padding-top: .3rem;
                    color: #555;
                }
                p{
                    font-size: .14rem;
                    @include flexbox;
                    padding: .25rem 0 .5rem 0;
                    span{
                        flex: 1;
                        color: #555;
                        b{
                            color: #000;
                        }
                    }
                }
            }
            .results{
                text-align: center;
                border-bottom: 1px dotted #249C24;
                margin: 0 .15rem;
                h4{
                    font-size: .18rem;
                    padding-top: .3rem;
                    color: #555;
                }
                p{
                    @include flexbox;
                    span{
                        color: #999;
                        font-size: .14rem;
                        @include flex;
                        
                    }
                    b{
                        @include flex;
                        font-size: .26rem;
                        color: #249C24;
                        font-family: 'PingFang-SC-Semibold';
                    }
                }
                .first-p{
                    padding: .25rem 0 .21rem 0;
                }
                .two-p{
                    padding-bottom: .47rem; 
                }
                .results-img{
                    div{
                        width: 100%;
                        img{
                            display: block;
                            margin: auto;
                        }
                        &:first-child{
                            padding-bottom: .91rem;
                        }
                        &:last-child{
                            padding-bottom: .6rem;
                        }
                    }
                    
                }
            }
            .jiedu-list{
                margin: 0 .15rem;
                padding-bottom: .1rem;
                h4{
                    font-size: .18rem;
                    color: #555555;
                    text-align: center;
                    padding: .3rem 0 .25rem 0; 
                }
                ul{
                    font-size: .16rem;
                    color: #666;
                    li{
                        padding-bottom: .25rem;
                        h6{
                            color: #555;
                        }
                        p{
                            padding-top: .1rem;
                           
                        }
                    }
                }
            }
            .report-footer{
                font-size: .14rem ;
                color: #555;
                font-weight: bold;
                text-align: center;
                padding-bottom: .55rem;
                p{
                    padding: .1rem 0;
                }
            }
        }
        
    }
</style>




// WEBPACK FOOTER //
// report.vue?cb589092